export const BRAND_NAME = 'smartQare';
export const PRODUCT_NAME = 'QareScan';

export const BRAND_LOGO_LABEL = `${BRAND_NAME} logo`;
export const BRAND_MARK_LABEL = `${BRAND_NAME} Q mark`;
